import React, { Fragment, useEffect, useState } from 'react'
import LeagueList from '../../components/league';
import HomeBannerSection from '../../components/home/homeBannerSection';
import Channel from '../../components/channel';
import Counter from '../../components/activitycounter'
import AdverticeAboutUsSection from '../../components/home/adverticeAboutUsSection';
import NewsTabSection from '../../components/home/newsTabSection';
import ImageAdvertiseHorizontal from '../../components/advertise/imageAdvertiseHorizontal';
import { isMobileOnly } from 'react-device-detect';
import axios from 'axios';
import { IAdvertiseData, ICountData, IPostData } from '../../interfaces/post';
import ComingSoonSection from '../../components/authentication/comingSoonSection';

interface IHomeData {
    "latest_news": IPostData[],
    "tab_data": {
        "headline"?: IPostData[],
        "trending"?: IPostData[],
        "videos"?: IPostData[]
    },
    "leagues": string[],
    "counts": ICountData[],
    "advertise": IAdvertiseData
}
export default function Home(props: any) {
    const [latestNewsData, setLatestNewsData] = useState<IPostData[]>([])
    const [headlineData, setHeadlineData] = useState<IPostData[]>([])
    const [trendingData, setTrendingData] = useState<IPostData[]>([])
    const [videosData, setVideosData] = useState<IPostData[]>([])
    const [leagueList, setLeagueList] = useState<string[]>([])
    const [countList, setCountList] = useState<ICountData[]>([])
    const [advertiseData, setAdvertiseData] = useState<IAdvertiseData>({})
    const getLatestNews = () => {
        axios.get('/dummy/homeData.json')
            .then((data) => {
                if (data?.data) {
                    const finalData = data?.data as IHomeData;
                    const LNData = finalData?.latest_news ? finalData?.latest_news : [];
                    const HData = finalData?.tab_data?.headline ? finalData.tab_data.headline : [];
                    const TRData = finalData?.tab_data?.trending ? finalData.tab_data.trending : [];
                    const VData = finalData?.tab_data?.videos ? finalData.tab_data.videos : [];
                    const LeagueData = finalData?.leagues ? finalData.leagues : [];
                    const CountData = finalData?.counts ? finalData.counts : [];
                    const adData = finalData?.advertise ? finalData.advertise : {};
                    setLeagueList(LeagueData)
                    setLatestNewsData(LNData)
                    setHeadlineData(HData)
                    setTrendingData(TRData)
                    setVideosData(VData)
                    setCountList(CountData)
                    setAdvertiseData(adData)
                }
            })
    }

    useEffect(() => {
        if (!props?.isComingSoon) {
            getLatestNews()
        }
    }, [])

    return (
        <Fragment>
            {props?.isComingSoon ?
                <ComingSoonSection maintenanceTime={props?.maintenanceTime} refresh={props?.refresh}/>
                :
                <>
                    <HomeBannerSection />
                    <LeagueList leagueList={leagueList} />
                    {isMobileOnly ?
                        <ImageAdvertiseHorizontal data={advertiseData} containerClass="mb-3" />
                        : null
                    }
                    <Channel />
                    <AdverticeAboutUsSection />
                    <Counter countList={countList} />
                    <NewsTabSection news={latestNewsData} headlines={headlineData} videos={videosData} trendings={trendingData} />
                </>
            }
        </Fragment>
    )
}
